import styled, { css } from 'styled-components'
import { Theme } from 'lib/ui/types'

interface TitleProps {
  theme: Theme
  primary?: boolean
  serif?: boolean
  flat?: boolean
}

export const titleCss = css`
  font-size: 32px;
  line-height: 1.6;
  font-family: ${(props: TitleProps) => props.serif ? props.theme.font.alt.family : props.theme.font.default.family};
  color: ${(props: TitleProps) => props.primary ? props.theme.palette.primary.alpha : props.theme.palette.general.headerColor};
  margin: 0 0 30px;
  padding: 0 0 10px;
  border-bottom: 1px solid ${props => props.theme.palette.general.soft};
  margin-bottom: ${(props: TitleProps) => props.flat ? '0' : '30px'};
  font-weight: 400;

  em {
    font-size: 0.6em;
    font-style: italic;
    color: ${(props: TitleProps) => props.primary ? props.theme.palette.primary.alpha : props.theme.palette.general.textColorLight};
  }
`

export const h1Css = css`
  font-size: 32px;
  line-height: 1.1;
  font-family: ${props => props.theme.font.alt.family};
  color: ${(props: TitleProps) => props.primary ? props.theme.palette.primary.alpha : props.theme.palette.general.headerColor};
  margin: 0 0 20px;
  font-weight: 400;
`

export const h4Css = css`
  font-family: ${(props: TitleProps) => props.serif ? props.theme.font.alt.family : props.theme.font.default.family};
  font-size: 20px;
  padding: 0;
  color: ${(props: TitleProps) => props.primary ? props.theme.palette.general.alpha : props.theme.palette.general.headerColor};
  margin: 0;
  margin-bottom: ${(props: TitleProps) => props.flat ? '0' : '20px'};
  font-weight: 400;
`

export const Title = styled.h1<any>`
  ${titleCss}
`

export const H1 = styled.h1<any>`
  ${h1Css}
`

export const H4 = styled.h4<any>`
  ${h4Css}
`
